const CLIENT_USER = 'ClientUser';
const CARDHOLDER = 'CardHolder';
const EML_USER = 'EmlUser';

export const USER_TYPES = {
  'CLIENT_USER': CLIENT_USER,
  'CARDHOLDER': CARDHOLDER,
  'EML_USER': EML_USER,
}
